module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAEPlp3DAAAAAXNSR0IArs4c6QAAAG9JREFUCB1Vjc0NgCAMRqkkhhX0TpiBm9PoTDoNN1bg565TkPqVqIk9tK8v/VE5512llFhJlFJW+rqukEgA9kSZjDHzb4SIjkGsTCEu59zWSa51QCJmHvEsgP0rnxqxsfQnImqtvrUWhLXWi7U2Ct+8DCn3r0ikpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sanjiao.png
// module id = IvgA
// module chunks = 22